export class WebviewApiError extends Error {

  constructor(code, message) {
    super(message);
    this.name = "WebviewApiError";
    this.code = code;
  }

  static unsupported(functionName) {
    return new WebviewApiError("unsupported", `Function ${functionName} isn't supported`);
  }

  toWebviewResponse() {
    return {
      ok: false,
      error: this,
    };
  }
}
